export const attachment = {
	name: 'attachment',
	title: 'Attachment',
	content:
		'<path d="M 23.25,9.9L12.273,20.878c-2.636,2.636-6.91,2.636-9.546,0s-2.636-6.91,0-9.546l9.016-9.015 c1.727-1.788,4.575-1.837,6.363-0.111c1.788,1.727,1.837,4.575,0.111,6.363c-0.036,0.037-0.073,0.074-0.111,0.111L9.091,17.7 c-0.894,0.863-2.318,0.839-3.182-0.055c-0.842-0.872-0.842-2.254,0-3.126L14.925,5.5" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
